
(function () {

  // =============================
  // CONFIG
  // =============================
  const getCurrency = () => Shopify.currency?.active || 'USD';

  // =============================
  // ADD TO CART TRACKING (AJAX)
  // =============================
  function trackAddToCart(data) {
    if (typeof fbq !== 'function') return;

    const items = data.items || [data];

    const contentIds = [];
    let totalValue = 0;

    items.forEach(item => {
      contentIds.push(item.id);

      // use presentment currency (important for multi-currency)
      const linePrice = item.final_line_price 
        ? item.final_line_price 
        : (item.price * item.quantity);

      totalValue += linePrice / 100;
    });

    fbq('track', 'AddToCart', {
      content_ids: contentIds,
      content_type: 'product',
      value: totalValue,
      currency: getCurrency()
    });
  }

  // Intercept ALL /cart/add requests
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(async (res) => {
      try {
        const url = arguments[0];

        if (typeof url === 'string' && url.includes('/cart/add')) {
          const cloned = res.clone();
          const data = await cloned.json();
          trackAddToCart(data);
        }
      } catch (e) {
        console.warn('AddToCart tracking error', e);
      }

      return res;
    });
  };


  // =============================
  // INITIATE CHECKOUT (GLOBAL)
  // =============================
  let checkoutTracked = false;

  function trackCheckout() {
    if (checkoutTracked) return;
    checkoutTracked = true;

    if (typeof fbq !== 'function') return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        fbq('track', 'InitiateCheckout', {
          num_items: cart.item_count,
          currency: getCurrency()
        });
      })
      .catch(() => {
        fbq('track', 'InitiateCheckout');
      });
  }


  document.addEventListener('submit', function (e) {
    if (e.target.action && e.target.action.includes('/checkout')) {
      trackCheckout();
    }
  });

  try {
    const origAssign = window.location.assign.bind(window.location);
    window.location.assign = function (url) {
      if (typeof url === 'string' && url.includes('/checkout')) trackCheckout();
      return origAssign(url);
    };

    const origReplace = window.location.replace.bind(window.location);
    window.location.replace = function (url) {
      if (typeof url === 'string' && url.includes('/checkout')) trackCheckout();
      return origReplace(url);
    };

    const origDescriptor = Object.getOwnPropertyDescriptor(window.location, 'href');
    if (!origDescriptor) {
      Object.defineProperty(window.location, 'href', {
        set: function (url) {
          if (typeof url === 'string' && url.includes('/checkout')) trackCheckout();
        },
        configurable: true
      });
    }
  } catch (e) {
    // location intercept not supported in this context
  }

  
  // Use capture phase (true) so this fires before iCart's handler can call stopPropagation()
  document.addEventListener('click', function (e) {
    const el = e.target.closest('a, button');
    if (!el) return;

    const href = el.getAttribute('href') || '';
    const name = el.getAttribute('name') || '';
    const classes = el.className || '';
    const id = el.getAttribute('id') || '';

    if (
      href.includes('/checkout') ||
      name === 'checkout' ||
      name === 'icartCheckout' ||
      classes.includes('icartCheckoutBtn') ||
      classes.includes('ssb--proceed') ||
      classes.includes('bp-gt--final-checkout-btn') ||
      classes.includes('bp-gt--floating-btn') ||
      (classes.includes('btn-primary') && !!el.closest('.wk-main')) ||
      (id === 'addToCart' && !!el.closest('#getNow'))
    ) {
      trackCheckout();
    }
  }, true);

})(); 


// =============================
// VIEW CONTENT (PRODUCT PAGES)
// =============================
(function () {
  if (typeof fbq !== 'function') return;
  if (!window.meta || !meta.product) return;

  const currency = Shopify.currency?.active || 'USD';

  const variant =
    meta.product.selectedVariant ||
    meta.product.variants[0];

  fbq('track', 'ViewContent', {
    content_ids: [variant.id],
    content_type: 'product',
    value: variant.price / 100,
    currency: currency
  });

})();